// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"be11cb8e","58":"87614cca","104":"2eccbce6","181":"1009ad97","479":"efb82ed1","490":"2df19715","491":"71ea3acd","520":"b464c9c3","522":"afba6752","616":"6fd6c3b4","693":"d31d1fe2","764":"03ba8922","836":"b3f7329b","854":"102f3922","910":"27eb719d"}[chunkId] + ".chunk.js";
};